import { eventListenerOptions } from '@spinnwerk/polyfills';

/**
 * Should not be called directly.
 * @see {@link floatingLabel}
 *
 * @param {object} [options={}]
 * @param {string} [options.containerClass='floating-label']
 * @private
 */
export function initFloatingLabel({ containerClass = 'floating-label' } = {}) {
    // mimic "label" when wrapper is none
    document.querySelectorAll(`.${containerClass}:not(label)`).forEach(pseudoLabel => {
        pseudoLabel.addEventListener(
            'click',
            event => {
                if (event.target === event.currentTarget || event.target.nodeName === 'LEGEND') {
                    event.currentTarget.querySelector('input, textarea, select').focus();
                }
            },
            eventListenerOptions({ passive: true }),
        );
    });

    function setActive(container) {
        container.classList.add('is-active');
    }

    function unsetActive(container) {
        container.classList.remove('is-active');
    }

    function focus(container) {
        container.classList.add('has-focus');
    }

    function blur(container) {
        container.classList.remove('has-focus');
    }

    const observer = new MutationObserver(mutations => {
        mutations.forEach(({ attributeName, target }) => {
            if (attributeName === 'disabled') {
                target.closest(`.${containerClass}`).classList.toggle('is-disabled', Boolean(target.disabled));
            }
        });
    });

    document.querySelectorAll(`.${containerClass}`).forEach(container => {
        let inputs = container.querySelectorAll(
            'input:not([type=submit]):not(.js-floating-label-exclude), textarea, select',
        );

        if (!inputs.length) {
            return;
        }

        inputs = Array.prototype.slice.call(inputs); // convert to Array

        if (inputs.some(input => input.value || input === document.activeElement)) {
            setActive(container);
        }

        container.addEventListener(
            'focusin',
            () => {
                focus(container);

                if (inputs.every(input => input.type !== 'file')) {
                    setActive(container);
                }
            },
            eventListenerOptions({ passive: true }),
        );

        container.addEventListener(
            'focusout',
            () => {
                blur(container);

                if (inputs.every(input => input.value === '' && input.nodeName !== 'SELECT' && input.type !== 'file')) {
                    unsetActive(container);
                }
            },
            eventListenerOptions({ passive: true }),
        );

        inputs.forEach(input => {
            if (input.type === 'file') {
                input.addEventListener('change', ({ currentTarget: input }) => {
                    let container = input.closest(`.${containerClass}`);

                    if (input.value) {
                        setActive(container);
                    } else {
                        let placeholder = container.querySelector('[data-placeholder]');

                        if (!placeholder || !placeholder.dataset.placeholder) {
                            unsetActive(container);
                        }
                    }
                });
            }

            observer.observe(input, { attributes: true });
        });
    });
}
